import copy from "clipboard-copy";
import { Location } from "vue-router";
import { User } from "@scrile/api-provider/dist/api/UserProvider";
import { UserPublicData, UserWithAvatar } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import { IS_BROWSER } from "@/lib/browserUtils";
import emitter from "@/lib/emitter";
import { FileType, isImageFile, isVideoFile } from "@/lib/fileHelpers";
import { MediaFilesController } from "@/lib/MediaFilesController";
import config from "@/config";
import { EVENTS } from "@/const";

declare type Resolutions = "240p" | "360p" | "480p" | "720p" | "1080p";

export function getAbsUrl(url: string) {
  return `${IS_BROWSER ? window.location.origin : ""}${url}`;
}

export function getProfileUrl(
  user: UserPublicData | UserWithAvatar | User | string,
  { feedId }: { feedId?: string } = {}
): Location {
  return {
    name: typeof user !== "string" ? "profile" : "profileById",
    params: {
      ...(typeof user !== "string" ? { username: user.username ?? "", userId: user.id } : { userId: user }),
    },
    ...(feedId ? { query: { feedId } } : {}),
  };
}

export const LOGO_URL = config.publicS3Url + "/logo";
export const DARK_LOGO_URL = config.publicS3Url + "/logo-dark";

export function getLiveUrl(user: UserPublicData | User): Location {
  return {
    name: "profile/live",
    params: {
      username: user.username,
    },
  };
}

export function getMassMessageUrl(groupIds: string[]): Location {
  return { name: "massMessage", params: { ids: groupIds.join(",") } };
}
export function getMessageUrl(user?: UserPublicData | User | null): Location {
  if (!user) return { name: "messages" };
  return { name: "messages", params: { userId: user.id } };
}

export async function shareUrl(url: string, notificationText?: string) {
  const useCopy = async (url: string, notificationText?: string) => {
    await copy(url);
    notificationText && emitter.emit(EVENTS.NOTIFICATION_SHOW, { text: notificationText });
  };
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if (typeof navigator !== "undefined" && navigator.share) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return navigator.share({ url }).catch(() => useCopy(url, notificationText));
  } else return useCopy(url, notificationText);
}

export const getMediaThumbnailUrl = (file: FileType, urlPart: string, width: Resolutions | number = "240p"): string => {
  return isImageFile(file)
    ? MediaFilesController.getImageThumbnail(urlPart, width)
    : isVideoFile(file)
      ? MediaFilesController.getVideoThumbnail(urlPart, width)
      : "/img/content-preview-media.png";
};
